import { render, staticRenderFns } from "./WaybillAccountShare.vue?vue&type=template&id=30e7f264&scoped=true"
import script from "./WaybillAccountShare.vue?vue&type=script&lang=js"
export * from "./WaybillAccountShare.vue?vue&type=script&lang=js"
import style0 from "./WaybillAccountShare.vue?vue&type=style&index=0&id=30e7f264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e7f264",
  null
  
)

export default component.exports